import { Theme } from '@mui/material';
import { Card } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { useRef } from 'react';
import { Icon } from 'ui/components/Icon';
import { IconButton } from 'ui/components/IconButton';
import { ChipType } from '../Filters';
import { FilterChips } from './FilterChips';

type FilterChipsInputProps = {
  chips: ChipType[];
  onClearAllFilters: () => void;
  onMenuClick?: React.MouseEventHandler<any>;
  variant?: 'primary' | 'secondary';
  sx?: SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>);
};

export const FilterChipsInput = ({
  chips,
  onClearAllFilters,
  onMenuClick,
  variant = 'primary',
  sx
}: FilterChipsInputProps) => {
  const filterCardRef = useRef<HTMLDivElement>(null);
  return (
    <Card
      variant="outlined"
      ref={filterCardRef}
      sx={theme => ({
        minHeight: 42,
        borderWidth: 1,
        backgroundColor: theme.palette.background.default,
        borderColor: variant === 'primary' ? theme.palette.primary.main : theme.palette.grey.A700,
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: `${onMenuClick ? 'auto' : ''} 1fr auto`,
        gap: '10px',
        alignItems: 'center',
        padding: '0 8px',
        ...(typeof sx === 'function' ? sx(theme) : sx)
      })}
    >
      {onMenuClick && (
        <IconButton onClick={onMenuClick} data-testid="openFiltersMenu">
          <Icon name="options" />
        </IconButton>
      )}
      <FilterChips
        chips={chips}
        onClearAllFilters={onClearAllFilters}
        filterBoxElementRef={filterCardRef}
        variant={variant}
      />
    </Card>
  );
};
